import Currency from 'views/commons/currencies/common/Currency';

export default {
	'components.Currency': {
		factory: Currency,
	},
};
